import { Box, Button } from '@mui/material'
import React from 'react'
import image from '../../images/notaccess.jpeg'
import { useNavigate } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material';


export default function NotAccessPage() {

  const navigate = useNavigate();

  return (
    <Box display='flex' sx={{ height: '90vh' }} alignItems='center' justifyContent='center' flexDirection='column'>
      <Box>
        <img
          alt="Under development"
          src={image}
          style={{
            marginTop: 50,
            display: 'inline-block',
            maxWidth: '100%',
            width: 560
          }}
        />
      </Box>
      <Box mt={3}>
        <Button variant='contained' onClick={() => {
          navigate(-1)
        }}
          startIcon={(<ArrowBack fontSize="small" />)}>
          Go back
        </Button>
      </Box>
    </Box>
  )
}
